import TokenBoxLoading from './TokenBoxLoading'

export default TokenBoxLoading